/*@flow*/
import type { StateRecord } from './types.js'; import Context from './context';
import { useContext } from 'react';

export default function useContextState(): StateRecord {
  const ctx = useContext(Context);
  return ctx.state;
}
